import React from 'react'
import { motion } from 'framer-motion'
import { useApp } from '../contexts/AppContext'
import SafeIcon from '../common/SafeIcon'
import * as FiIcons from 'react-icons/fi'

const { FiHeart, FiCode } = FiIcons

const Footer = () => {
  const { currentLang, translations } = useApp()
  const currentYear = new Date().getFullYear()

  return (
    <motion.footer
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.8, delay: 0.8 }}
      className="py-6 sm:py-8 text-center text-gray-500 dark:text-gray-400 border-t border-gray-200 dark:border-gray-800"
    >
      <div className="max-w-4xl mx-auto px-4 space-y-3 sm:space-y-4">
        {/* Copyright - Mobile Optimized */}
        <p className="text-xs sm:text-sm">
          {translations.footerCopyright[currentLang].replace('2025', currentYear)}
        </p>

        {/* Developer Info - Mobile Optimized */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-1 sm:gap-2 text-xs">
          <div className="flex items-center gap-1 sm:gap-2">
            <SafeIcon icon={FiCode} className="w-3 h-3 text-blue-500" />
            <span className="text-gray-400 dark:text-gray-500">
              {translations.footerMadeBy[currentLang]}
            </span>
            <SafeIcon icon={FiHeart} className="w-3 h-3 text-red-500 animate-pulse" />
          </div>
          <a
            href={translations.footerCompanyUrl[currentLang]}
            target="_blank"
            rel="noopener noreferrer"
            className="text-purple-600 dark:text-purple-400 font-medium hover:text-purple-700 dark:hover:text-purple-300 transition-colors duration-200"
          >
            {translations.footerCompany[currentLang]}
          </a>
        </div>
      </div>
    </motion.footer>
  )
}

export default Footer